import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Report to Sentry if available
    if (window.__SENTRY__) {
      try {
        const Sentry = require('@sentry/react');
        Sentry.captureException(error, { extra: { componentStack: errorInfo?.componentStack } });
      } catch { /* Sentry not loaded */ }
    }
  }

  handleTryAgain = () => {
    this.setState({ hasError: false, error: null }, () => {
      window.location.reload();
    });
  };

  render() {
    if (this.state.hasError) {
      const isNetwork = this.state.error?.message?.includes('fetch') || this.state.error?.message?.includes('Network');
      return (
        <div style={styles.container} role="alert">
          <div style={styles.card}>
            <div style={styles.iconCircle}>
              <span style={styles.icon} aria-hidden="true">{isNetwork ? '📡' : '!'}</span>
            </div>
            <h1 style={styles.title}>{isNetwork ? 'Connection problem' : 'Something went wrong'}</h1>
            <p style={styles.message}>
              {isNetwork
                ? 'Unable to reach the server. Please check your internet connection and try again.'
                : 'An unexpected error occurred. Please try again or contact support if the problem persists.'}
            </p>
            <button style={styles.button} onClick={this.handleTryAgain}>
              Reload Page
            </button>
            <p style={{ fontSize: '0.8rem', color: '#9ca3af', marginTop: 16, marginBottom: 0 }}>
              If this keeps happening, email <a href="mailto:support@cardlockr.com" style={{ color: '#4F46E5' }}>support@cardlockr.com</a>
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #4F46E5, #7C3AED)',
    fontFamily: 'Arial, sans-serif',
    padding: '1rem',
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '3rem 2.5rem',
    maxWidth: '460px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.25)',
  },
  iconCircle: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4F46E5, #7C3AED)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 1.5rem',
  },
  icon: {
    color: '#ffffff',
    fontSize: '2rem',
    fontWeight: 'bold',
    lineHeight: 1,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 0.75rem',
  },
  message: {
    fontSize: '1rem',
    color: '#6b7280',
    lineHeight: '1.6',
    margin: '0 0 2rem',
  },
  button: {
    background: 'linear-gradient(135deg, #4F46E5, #7C3AED)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 2rem',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: 'Arial, sans-serif',
  },
};

export default ErrorBoundary;
